import React, { useEffect } from 'react'
import { useParams, Link }         from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBookingDetail }      from '../../store/reducers/HyperDeliveryReducer'

export default function HyperDeliveryDetail() {
  const { orderId } = useParams()
  const dispatch   = useDispatch()
  const {
    bookingDetail: booking,
    orderDetail:   order,
    detailLoading: loading,
    detailError:   error
  } = useSelector(s => s.hyperDeliveryList)

  useEffect(() => {
    if (orderId) dispatch(fetchBookingDetail(orderId))
  }, [dispatch, orderId])

  if (loading) return <p className="p-4">Loading details…</p>
  if (error)   return <p className="p-4 text-red-500">Error: {error}</p>
  if (!booking || !order) return <p className="p-4">No details available.</p>

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow space-y-6">
      <Link to="/dashboard/hyper-delivery" className="text-indigo-600 hover:underline">
        ← Back to list
      </Link>

      <h2 className="text-3xl font-semibold">Delivery Details</h2>

      {/* Borzo Booking Info */}
      <section className="space-y-2">
        <h3 className="text-xl font-medium">Borzo Booking</h3>
        <p><strong>Borzo Order ID:</strong> {booking.borzoOrderId}</p>
      
        <p><strong>Current Status:</strong> {booking.status.replace(/_/g,' ')}</p>
        <div>
          <h4 className="font-medium">Status Timeline</h4>
          <ul className="list-disc list-inside text-sm">
            {booking.statusHistory.map((evt,i) => (
              <li key={i}>
                <span className="font-semibold">
                  {new Date(evt.timestamp).toLocaleString()}
                </span> — {evt.code.replace(/_/g,' ')}: {evt.description}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Shipping Addresses */}
      <section className="grid grid-cols-2 gap-6">
        <div>
          <h4 className="font-medium">Pickup Address</h4>
          <p>{booking.pickupAddress.raw}</p>
        </div>
        <div>
          <h4 className="font-medium">Drop Address</h4>
          <p>{booking.dropAddress.raw}</p>
        </div>
      </section>

      {/* Original Order Info */}
      <section className="space-y-2">
        <h3 className="text-xl font-medium">Order #{orderId}</h3>
        <p><strong>Placed On:</strong> {new Date(order.createdAt).toLocaleString()}</p>

        <h4 className="font-medium">Products</h4>
        <div className="space-y-4">
          {order.products.map((item, idx) => {
            const info = item.productInfo || {}
            const img  = info.images?.[0] || '/placeholder.png'
            return (
              <div key={idx} className="flex items-center space-x-4">
                <img
                  src={img}
                  alt={info.name || 'Product'}
                  className="w-16 h-16 rounded object-cover"
                />
                <div className="flex-1">
                  <p className="font-medium">{info.name || 'Unknown Product'}</p>
                  {info.brand && <p className="text-sm text-gray-500">{info.brand}</p>}
                </div>
                <div className="text-right">
                  <p>Qty: {item.quantity}</p>
                  <p>
                    ₹
                    {info.price
                      ? (info.price * item.quantity).toFixed(2)
                      : '0.00'}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
        <div className="flex justify-end font-semibold">
          <span>Total:</span>
          <span className="ml-2">₹{(order.price ?? 0).toFixed(2)}</span>
        </div>
      </section>
    </div>
  )
}
